import React from "react"

import BlogPostsSectionDesktop from "./BlogPostsSectionDesktop"

const BlogPostsSectionMobile = (props) => <BlogPostsSectionDesktop {...props} />

export default BlogPostsSectionMobile
